module.exports = __webpack_public_path__ + "static/media/household_door_wooden_internal_shut_013.10c89d3f.wav";